var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select-vat',{attrs:{"value":_vm.value,"hide-details":"auto"},on:{"input":_vm.onVatChange}})}
var staticRenderFns = []

export { render, staticRenderFns }